/**
 * AntragVerwerfenDialog - «Verwerfen» (Tab 5a, P2 Slice 13). A grund (>= 3) is required.
 */

import { useState } from 'react';
import { ANTRAG_VERWERFEN_HINWEIS, type AntragVerwerfenBody } from '@brokly/shared';
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';

export function AntragVerwerfenDialog({
  open,
  onClose,
  onVerwerfen,
  saving,
  error,
}: {
  open: boolean;
  onClose: () => void;
  onVerwerfen: (body: AntragVerwerfenBody) => void;
  saving: boolean;
  error: { code?: string } | null;
}) {
  const [grund, setGrund] = useState('');
  const errorText = error?.code ? 'Verwerfen fehlgeschlagen' : null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Antrag verwerfen"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>Abbrechen</Button>
          <Button variant="destructive" disabled={saving || grund.trim().length < 3} onClick={() => onVerwerfen({ grund: grund.trim() })} data-testid="antrag-verwerfen-submit">
            Antrag verwerfen
          </Button>
        </div>
      }
    >
      <div className="space-y-3 text-sm" data-testid="antrag-verwerfen-dialog">
        <p className="text-xs text-muted-foreground">{ANTRAG_VERWERFEN_HINWEIS}</p>
        <label className="block">
          <span className="text-xs text-muted-foreground">Grund</span>
          <textarea value={grund} onChange={(e) => setGrund(e.target.value)} rows={3} maxLength={2000} className="mt-1 w-full rounded-md border border-border p-2" data-testid="antrag-verwerfen-grund" />
        </label>
        {errorText && <p className="text-sm text-status-danger" data-testid="antrag-verwerfen-error">{errorText}</p>}
      </div>
    </Dialog>
  );
}
